export default "__VITE_ASSET__ChsqBUru__"